
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, UsuarioActual } from "../login-controlador";
    import { Email } from '@/__env/ext';

    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {
        get Controlador() { return Model; }
        get UsuarioActual() { return UsuarioActual; }

        Estado: 'cargando' | 'iniciado' = 'iniciado';
        MostrarPassword: boolean = false;
        Error: string = '';
        Password: string = '';

        @Prop()
        Visible: boolean;
        @Watch( 'Visible' )
        onVisible()
        {
            this.Estado = 'iniciado';
            this.Error = '';
            this.Password = '';
            this.MostrarPassword = false;
        }

        public async Comprobar()
        {


            if ( this.Password.length < 3 )
            {
                this.Password = '';
                document.getElementById( 'text-password' ).focus();
                this.Error = '¡Ingresá una contraseña válida!';
                return;
            }

            this.Estado = 'cargando';
            let response = await this.Controlador.Autenticar( this.Password );
            this.Password = '';
            if ( response.resultado)
            {
                await this.$router.push( this.Controlador.Redireccionar ? this.Controlador.Redireccionar : '/' );
            }
            else
            {
                this.Password = '';
                this.Error = response.mensaje;
                document.getElementById( 'text-password' ).focus();
                this.Estado = 'iniciado';
            }

        }

    }
